/* eslint-disable react/react-in-jsx-scope */
import { CodeSnippet } from '@backstage/core-components';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  summary: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  filePath: {
    fontFamily: 'monospace',
    fontSize: '0.85rem',
    flexGrow: 1,
  },
  additions: {
    color: theme.palette.success?.main ?? '#4caf50',
    fontWeight: 600,
    fontSize: '0.8rem',
    minWidth: 40,
    textAlign: 'right',
  },
  deletions: {
    color: theme.palette.error.main,
    fontWeight: 600,
    fontSize: '0.8rem',
    minWidth: 40,
    textAlign: 'right',
  },
}));

interface FileChangeAccordionProps {
  filePath: string;
  diff: string;
  additions: number;
  deletions: number;
  defaultExpanded?: boolean;
}

export function FileChangeAccordion({
  filePath,
  diff,
  additions,
  deletions,
  defaultExpanded = false,
}: FileChangeAccordionProps) {
  const classes = useStyles();

  return (
    <Accordion defaultExpanded={defaultExpanded} variant="outlined">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box className={classes.summary}>
          <Typography className={classes.filePath}>{filePath}</Typography>
          {additions > 0 && (
            <Typography className={classes.additions}>+{additions}</Typography>
          )}
          {deletions > 0 && (
            <Typography className={classes.deletions}>-{deletions}</Typography>
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails style={{ padding: 0 }}>
        <Box width="100%" overflow="auto">
          <CodeSnippet text={diff} language="diff" showCopyCodeButton />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
